import { cva } from "class-variance-authority";

export const SELECT_STATES = {
  NORMAL: "normal",
  ERROR: "error",
} as const;

export type SelectState = (typeof SELECT_STATES)[keyof typeof SELECT_STATES];

export const selectTriggerVariants = cva(
  "flex w-full items-center justify-between whitespace-nowrap px-3 py-2 text-[15px] font-normal text-gray-700 [&>span]:line-clamp-1",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outlined: "bg-white border border-gray-300 hover:border-gray-400 focus:border-gray-400 focus:outline-none focus:ring-0 rounded-lg",
      },
      size: {
        default: "h-14 min-h-[56px]",
        compact: "h-10 min-h-[40px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export const SELECT_STYLES = {
  floatingLabel:
    "absolute left-3 -top-2 bg-white px-1 text-xs text-gray-600 transition-all peer-placeholder-shown:top-2 peer-placeholder-shown:left-3 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:left-2 peer-focus:text-xs",
  scrollButton: "flex cursor-default items-center justify-center py-1",
  content:
    "relative z-[65] max-h-[--radix-select-content-available-height] min-w-[8rem] overflow-y-auto overflow-x-hidden bg-white rounded-xl border-gray-100 shadow-md text-gray-700 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-select-content-transform-origin]",
  popperPosition:
    "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
  viewport: "p-2",
  popperViewport:
    "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]",
  label: "px-2 py-1.5 text-[15px] font-medium text-gray-700",
  item: "relative flex w-full cursor-pointer select-none items-center rounded-lg py-2.5 sm:pl-3 pr-2 text-[15px] text-gray-700 outline-none hover:bg-gray-50 data-[highlighted]:bg-gray-100 data-[highlighted]:text-gray-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
  separator: "-mx-1 my-1 h-px bg-muted",
} as const;
